import {
  CommonLimitedListState,
  CommonPuppeteerLimitedListState,
} from "../../../types";
import {
  ASHComponentCardAttributes,
  ASHComponentHeaderAttributesProps,
} from "../ASHComponentCard";

const getLimitedListHeaderFields: ASHComponentCardAttributes<
  CommonLimitedListState | CommonPuppeteerLimitedListState
> = ({
  componentState,
  agentConfig,
}: ASHComponentHeaderAttributesProps<
  CommonLimitedListState | CommonPuppeteerLimitedListState
>) => {
  const componentConfig =
    componentState?.id &&
    agentConfig?.config?.component_configs?.[componentState?.id];
  const maxEntries = componentConfig?.config?.max_entries;
  return [
    {
      name: "current_size",
      label: "Current Size",
      value: componentState?.state?.data?.length,
    },
    {
      name: "max_size",
      label: "Max Size",
      value: maxEntries,
    },
  ];
};

export default getLimitedListHeaderFields;
